
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { MortgageData } from "../../CalculatorTabs";
import { calculateMortgageData } from "@/utils/calculator/mortgageCalculator";
import { AutoCalculateOptions } from "../../utils/types";
import { MetricTooltip } from "../../advanced/analytics/MetricTooltip";

interface PropertyTypeSelectorProps {
  mortgageData: MortgageData;
  setMortgageData: React.Dispatch<React.SetStateAction<MortgageData>>;
  autoCalculate: AutoCalculateOptions;
}

const PropertyTypeSelector: React.FC<PropertyTypeSelectorProps> = ({ 
  mortgageData, 
  setMortgageData, 
  autoCalculate 
}) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">Property Type <MetricTooltip metric="propertyType" /></Label>
      <Select 
        value={mortgageData.propertyType}
        onValueChange={(value: "singleFamily" | "condo" | "townhouse" | "multifamily") => {
          setMortgageData(prev => calculateMortgageData({
            ...prev,
            propertyType: value
          }));
        }}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="singleFamily">Single Family</SelectItem>
          <SelectItem value="condo">Condo</SelectItem>
          <SelectItem value="townhouse">Townhouse</SelectItem>
          <SelectItem value="multifamily">Multi-Family</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default PropertyTypeSelector;
